export const getTabDocumentsSelector = state => state.tabDocuments;
